
import {Modal} from '../../../ui-library';
import React from 'react';
import {CancelBtn, Content, ModalBox, ModalTitle, ButtonsBox, YesBtn} from '../Style/BeforeExitModal.style';
import {IPropsView} from '../Config/BeforeExitModal.types';

const BeforeExitModalView = ({ open, setOpen, onClick, title, content, cancelTitle, yesTitle, yestextcolor = 'primary'}:IPropsView) => (
    <Modal
        open={open}>
        <>
            <ModalBox>
                <ModalTitle>{title}</ModalTitle>
                <Content>{content}</Content>
                <ButtonsBox>
                    <CancelBtn size='medium' onClick={() => setOpen(false)}>{cancelTitle}</CancelBtn>
                    <YesBtn size='medium' yestextcolor={yestextcolor} onClick={onClick}>{yesTitle}</YesBtn>
                </ButtonsBox>
            </ModalBox>
        </>
    </Modal>
);

export default BeforeExitModalView;
